import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { MF } from 'react-mf';
import { extractLabelsNumbers, extractNumber, } from '../../../data/molecules/MoleculeManager';
import { useDispatch } from '../../context/DispatchContext';
import EditableColumn from '../../elements/EditableColumn';
import Label from '../../elements/Label';
const styles = {
    toolbar: {
        display: 'flex',
        borderBottom: '0.55px solid rgb(240, 240, 240)',
        padding: '5px 10px',
        justifyContent: 'space-between',
    },
    labelInput: {
        width: '150px',
        border: '1px solid #f4f4f4',
        borderRadius: '5px',
        cursor: 'pointer',
        textAlign: 'center',
        marginLeft: '5px',
    },
};
export default function MoleculeHeader(props) {
    const { currentMolecule, molecules } = props;
    const dispatch = useDispatch();
    const validateLabel = useCallback((value) => {
        const reservedNumbers = extractLabelsNumbers(molecules);
        const number = extractNumber(value);
        return value && !reservedNumbers.includes(Number(number));
    }, [molecules]);
    const saveLabelHandler = useCallback((id, event) => {
        const label = event.target.value;
        dispatch({ type: 'CHANGE_MOLECULE_LABEL', payload: { label, id } });
    }, [dispatch]);
    return (_jsxs("div", { style: styles.toolbar, children: [_jsx(Label, { title: "Label", children: _jsx(EditableColumn, { value: currentMolecule.label, style: styles.labelInput, validate: validateLabel, onSave: (event) => saveLabelHandler(currentMolecule.id, event), textOverFlowEllipses: true }) }), _jsxs("span", { children: [_jsx(MF, { mf: currentMolecule.mf }), " - ", currentMolecule.mw?.toFixed(2)] })] }));
}
